import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { previewProductRecord, previewTitleRecord, } from "../api/previewService";
/**
 * Fetches the record preview for the given target in the given format.
 *
 * The query is keyed on target + format so switching format refetches (and caches)
 * each format independently. Disabled until {@code enabled} is true so the modal
 * only fetches once opened.
 */
export var useRecordPreview = function (target, format, enabled) {
    var ky = useOkapiKy();
    return useQuery(["record-preview", target.kind, target.id, format], function () {
        return target.kind === "title"
            ? previewTitleRecord(ky, target.id, format)
            : previewProductRecord(ky, target.id, format);
    }, { enabled: enabled && !!target.id });
};
